import { FC } from 'react'
import { IInvestmentBase } from '../../../types'
import { getCompanyLogo } from '../../../utils'
import { Avatar } from '../../atoms/Avatar'
import { VerifiedName } from '../../atoms/VerifiedName'
import { CommentCard } from '../../organisms/CommentCard'

type Props = {
  item: IInvestmentBase
}

export const StartupCommentCard: FC<Props> = ({ item }) => {
  // 現状 status が published の会社しか item に入ることはないが、今後 closed な会社が入る可能性があるので href に条件を記載した
  const href = item.company.status === 'published' ? `/companies/${item.company.slug}` : ''
  return (
    <CommentCard
      comment={item.startupComment?.comment}
      href={href}
      renderLogo={() => <Avatar src={getCompanyLogo(item.company)} alt={item.company?.name} />}
      renderName={() => <VerifiedName name={item.company?.name} isVerifiedAccount={false} />}
    />
  )
}
